import React, { useReducer, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap'
import { CusButton } from '../../Components/From/Button';
import { FormattedMessage } from 'react-intl';
import PerfectScrollbar from 'react-perfect-scrollbar';
import cls from 'classnames';

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function Tool__CusSp({
  takeoutTaste,
  dineInTaste,
  productName,
  specName,
  takeoutState,
  disableTakeoutState,
  disableTasteList = false,
  disableConfirmBtn = false,
  selectedItems,
  onClose,
  onSelectItem,
  applyModeState
}) {
  console.log(takeoutTaste);
  const [state, dispatch] = useReducer(reducer, {
    selected: pickDefaultTaste(),
    takeoutState: takeoutState
  });

  function pickDefaultTaste() {
    if (selectedItems) {
      return selectedItems;
    } else {
      const whichTaste = takeoutState ? takeoutTaste : dineInTaste;
      const defaultTaste = whichTaste.filter(def => def.preset).map(e => e.id);
      return defaultTaste;
    }
  }

  function selectDiningType(diningType) {
    let defaultTaste;
    switch (diningType) {
      case 'dineIn':
        defaultTaste = dineInTaste.filter(def => def.preset).map(e => e.id);
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'takeoutState', val: false },
            { key: 'selected', val: defaultTaste }
          ]
        });
        break;
      case 'takeout':
        defaultTaste = takeoutTaste.filter(def => def.preset).map(e => e.id);
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'takeoutState', val: true },
            { key: 'selected', val: defaultTaste }
          ]
        });
        break;
      default:
        console.error('defaultTaste error');
    }
  }

  return (
    <Modal
      isOpen
      fade={false}
      backdrop={false}
    >
      <div className="Tool Tool__CusSp d-flex justify-content-center align-items-center">
        <div className="Tool__CusSp__content d-flex flex-column p-4">
          <div className="Tool__CusSp__title">{productName}</div>
          <div className="Tool__CusSp__subtitle">{specName}</div>
          <hr className="" />
          {!disableTakeoutState && (
            <div className="Tool__CusSp__optionContent Tool__CusSp__optionContent_normal d-flex clearfix mb-3">
              <a
                className={cls(
                  'Tool__CusSp__option d-flex justify-content-center align-items-center p-2 dineIn-option',
                  !state.takeoutState ? 'Tool__CusSp__option_select' : '',
                  applyModeState === 3 ? 'Tool__CusSp__option_disabled' : ''
                )}
                onClick={() => {
                  selectDiningType('dineIn');
                }}
              >
                <FormattedMessage id="popup.buttonDineIn" />
              </a>
              <a
                className={cls(
                  'Tool__CusSp__option d-flex justify-content-center align-items-center p-2 takeoutOption',
                  state.takeoutState ? 'Tool__CusSp__option_select' : '',
                  applyModeState === 2 ? 'Tool__CusSp__option_disabled' : ''
                )}
                onClick={() => {
                  selectDiningType('takeout');
                }}
              >
                <FormattedMessage id="popup.buttonTakeout" />
              </a>
            </div>
          )}
          <div translate="no" className="Tool__CusSp__optionContent d-flex flex-column col p-0 clearfix" style={{ height: 0 }}>
            <PerfectScrollbar className="col p-0" >
              {(() => {
                if (disableTasteList) return null;
                let renderTaste;
                if (state.takeoutState) renderTaste = takeoutTaste;
                if (!state.takeoutState) renderTaste = dineInTaste;
                return renderTaste.map((e, index) => (
                  <a
                    key={index}
                    className={cls(
                      'Tool__CusSp__option p-2',
                      state.selected.find(f => f === e.id)
                        ? 'Tool__CusSp__option_select'
                        : '',
                      state.selected.length >= 7
                        ? 'Tool__CusSp__option_disabled'
                        : ''
                    )}
                    onClick={() => {
                      let newVal = [...state.selected];
                      const isSelected = newVal.find(f => f === e.id);
                      if (isSelected) {
                        const findIndex = newVal.findIndex(f => f === e.id);
                        newVal.splice(findIndex, 1);
                      } else {
                        e.exclusion.forEach(i => {
                          const findIndex = newVal.findIndex(f => f === i);
                          if (findIndex > -1) newVal.splice(findIndex, 1);
                        });
                        newVal.push(e.id);
                      }
                      dispatch({
                        type: 'UPDATE_STATE',
                        payload: [{ key: 'selected', val: newVal.sort() }]
                      });
                    }}
                  >
                    <div className="mb-2">{e.name}</div>
                    <div className="mb-2">
                      {e.price === 0 ? '' : `+ $ ${e.price}`}
                    </div>
                  </a>
                ));
              })()}
            </PerfectScrollbar>
          </div>
          <div className="row align-items-center justify-content-center my-2">
            <div className='col-6 col-lg-3'>
              <CusButton.White
                children={
                  <FormattedMessage id="popup.buttonBack" />
                }
                className="btn-block py-2 addmeal-back"
                onClick={() => onClose(false)}
              />
            </div>
            {disableConfirmBtn ? null : (
              <div className='col-6 col-lg-3'>
                <CusButton.Red
                  children={
                    <FormattedMessage id="popup.buttonConfirm" />
                  }
                  className="btn-block py-2 addmeal-confirm"
                  onClick={() => {
                    onSelectItem({
                      taste: state.selected,
                      takeoutState: state.takeoutState
                    });
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default Tool__CusSp;
